export const CREDITOPTIONDETAIL_LOADING = "CREDITOPTIONDETAIL_LOADING";
export const CREDITOPTIONDETAIL_RESET = "CREDITOPTIONDETAIL_RESET";
export const GET_CREDITOPTIONDETAIL = "GET_CREDITOPTIONDETAIL";
export const GET_CREDITOPTIONDETAIL_SUCCESS = "GET_CREDITOPTIONDETAIL_SUCCESS";
export const GET_CREDITOPTIONDETAIL_FAIL = "GET_CREDITOPTIONDETAIL_FAIL";
export const DELETE_CREDITOPTIONDETAIL = "DELETE_CREDITOPTIONDETAIL"
export const DELETE_CREDITOPTIONDETAIL_SUCCESS = "DELETE_CREDITOPTIONDETAIL_SUCCESS"
export const DELETE_CREDITOPTIONDETAIL_FAIL = "DELETE_CREDITOPTIONDETAIL_FAIL"
export const UPDATE_CREDITOPTIONDETAIL = "UPDATE_CREDITOPTIONDETAIL"
export const UPDATE_CREDITOPTIONDETAIL_SUCCESS = "UPDATE_CREDITOPTIONDETAIL_SUCCESS"
export const UPDATE_CREDITOPTIONDETAIL_FAIL = "UPDATE_CREDITOPTIONDETAIL_FAIL"
export const ADD_NEW_CREDITOPTIONDETAIL = "ADD_NEW_CREDITOPTIONDETAIL"
export const ADD_CREDITOPTIONDETAIL_SUCCESS = "ADD_CREDITOPTIONDETAIL_SUCCESS"
export const ADD_CREDITOPTIONDETAIL_FAIL = "ADD_CREDITOPTIONDETAIL_FAIL"